<template>
  <div>
    <v-dialog
      v-model="open"
      max-width="1035"
      persistent
      :hide-overlay="hideOverlay"
    >
      <v-card tile :disabled="createList.loading || editList.loading">
        <v-toolbar>
          <v-spacer></v-spacer>
          <v-toolbar-title
            class="headline font-weight-bold text-center px-md-10"
          >
            {{ edit ? 'Edit list' : 'Create a List' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="onClose">
            <v-icon color="black" large>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form
            id="list-form"
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit(edit ? 'edit' : 'create')"
          >
            <v-container class="card-body pt-16">
              <v-row justify="center">
                <v-col cols="12" sm="5">
                  <v-text-field
                    v-model="listName"
                    :rules="listNameRules"
                    label="List Name"
                    required
                    outlined
                    rounded
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="edit" justify="center">
                <v-col cols="12" sm="5">
                  <v-btn
                    color="bluelink"
                    text
                    class="text-none"
                    @click="deleteOpen = true"
                  >
                    <span>Delete this list</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center py-6 d-flex elevation-6">
          <v-btn
            rounded
            color="primary"
            class="text-none submit-button"
            type="submit"
            form="list-form"
            :disabled="!valid"
            :loading="createList.loading || editList.loading"
          >
            {{ edit ? 'Save Changes' : 'Create New List' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-delete-dialog
      :open="deleteOpen"
      @close="onDelete"
    ></confirm-delete-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ConfirmDeleteDialog from './ConfirmDeleteDialog.vue'

export default {
  components: {
    ConfirmDeleteDialog,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    list: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      valid: false,
      listName: '',
      deleteOpen: false,
      listNameRules: [
        (v) => !!v || 'List Name is required',
        () =>
          (this.createList.error === null && this.editList.error === null) ||
          'List Name already exists',
      ],
    }
  },
  computed: {
    ...mapState('lists', ['createList', 'editList', 'deleteList']),
  },
  mounted() {
    this.$store.commit('lists/clearCreateList')

    if (this.edit) {
      this.listName = this.list.name
    }
  },
  methods: {
    onClose() {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.$emit('close')
    },
    onDelete(confirm) {
      if (confirm) {
        this.onSubmit('delete')
      }
    },
    onSubmit(action) {
      switch (action) {
        case 'delete': {
          this.deleteOpen = false

          this.$store
            .dispatch('lists/DELETE_LIST/REQUEST', {
              id: this.list.id,
            })
            .then(() => {
              if (this.deleteList.data !== null) {
                this.$emit('submit', { name: this.listName })
                this.$refs.form.reset()
                this.$refs.form.resetValidation()
              }

              if (this.deleteList.error !== null) {
                this.$refs.form.validate()
                this.$store.commit('lists/clearCreateList')
              }
            })

          break
        }
        case 'edit': {
          this.$store
            .dispatch('lists/EDIT_LIST/REQUEST', {
              name: this.listName,
              id: this.list.id,
            })
            .then(() => {
              if (this.editList.data !== null) {
                this.$emit('submit', { name: this.listName })
                this.$refs.form.reset()
                this.$refs.form.resetValidation()
              }

              if (this.editList.error !== null) {
                this.$refs.form.validate()
                this.$store.commit('lists/clearCreateList')
              }
            })
          break
        }
        default: {
          this.$store
            .dispatch('lists/CREATE_LIST/REQUEST', { name: this.listName })
            .then(() => {
              if (this.createList.data !== null) {
                this.$emit('submit', { name: this.listName })
                this.$refs.form.reset()
                this.$refs.form.resetValidation()
              }

              if (this.createList.error !== null) {
                this.$refs.form.validate()
                this.$store.commit('lists/clearCreateList')
              }
            })
          break
        }
      }
    },
  },
}
</script>

<style scoped>
.submit-button {
  min-width: 15rem !important;
}
.card-body {
  min-height: 20rem !important;
}
</style>
